import { api } from '@/api';
import {
  GetBeamShapingGroupDtoTypeEnum,
  instanceOfMvTherapySystemSetupDto,
  MedicalSystemSetupBaseDto,
  TaskTypeDescription,
} from '@/api/generator';
import { SelectItemType } from '@/components/forms/types.ts';
import { isNumber } from 'lodash';
import type { ComputedRef, InjectionKey } from 'vue';

export const bccBeamShapingRectangularFieldSizeXOptionsInjectionKey: InjectionKey<
  ComputedRef<SelectItemType<number>[]>
> = Symbol();

export async function getBeamShapingTemplate(
  medicalSystemSetup: MedicalSystemSetupBaseDto,
  taskType: TaskTypeDescription,
) {
  const radiationFieldShapeId = instanceOfMvTherapySystemSetupDto(medicalSystemSetup)
    ? medicalSystemSetup?.beamShapingContainer?.availableBeamShaping?.radiationFieldShape
        ?.options?.[0].id
    : undefined;

  if (isNumber(radiationFieldShapeId)) {
    const { result } = await api.taskItemsApi.getTaskItemBeamShapingTemplate({
      getBeamShapingGroupDto: {
        taskType,
        radiationFieldShapeId,
        $type:
          GetBeamShapingGroupDtoTypeEnum.PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoGetBeamShapingGroupDtoPtwPtw100AppZeroApplicationShared,
      },
    });

    return result;
  } else {
    console.error('Option ID could not be set');
  }
}
